import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'i2a-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {
  @Input() light: boolean;

  constructor() { }

  ngOnInit() {
  }

}
